<template>
    <div class="card mb-25 border-0 rounded-0 bg-white add-user-card">
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
            <Form ref="filiereNiveauMatiereForm" @submit="addFiliereNiveauMatiere" :validation-schema="filiereNiveauMatiereSchema">
              <div class="row">
              <div class="col-md-4">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10">
                  Filières <span class="text-danger">*</span>
                </label>
                <Field  name="filiere"  v-slot="{ field }">
                  <Multiselect
                    :options="filiereOptions"
                    :searchable="true"
                    track-by="label"
                    label="label"
                    v-model = "field.value"
                    v-bind = "field"
                    placeholder="Sélectionner la filière"
                  />
                </Field>
                <ErrorMessage name="filiere" class="text-danger"/>
              </div>
            </div>
             <div class="col-md-4">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10">
                Niveau <span class="text-danger">*</span>
                </label>
                <Field  name="niveau"  v-slot="{ field }">
                  <Multiselect
                    :options="niveauOptions"
                    :searchable="true"
                    track-by="label"
                    label="label"
                    v-model = "field.value"
                    v-bind = "field"
                    placeholder="Sélectionner le niveau"
                  />
                </Field>
                <ErrorMessage name="niveau" class="text-danger"/>
              </div>
            </div>
                <div class="col-md-4">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10">
                Matière <span class="text-danger">*</span>
                </label>
                <Field  name="matiere"  v-slot="{ field }">
                  <Multiselect
                    :options="matiereOptions"
                    :searchable="true"
                    track-by="label"
                    label="label"
                    v-model = "field.value"
                    v-bind = "field"
                    placeholder="Sélectionner la matière"
                  />
                </Field>
                <ErrorMessage name="matiere" class="text-danger"/>
              </div>
            </div>
             <div class="col-md-4 mb-3">
                    <label for="coefficient" class="form-label">Coefficient</label>
                    <Field name="coefficient" class="form-control" type="number"/>
                    <ErrorMessage name="coefficient" class="text-danger" />
            </div>
              
          <div class="col-md-12 mt-3" >
            <div class="d-flex align-items-center ">
              <button
                class="default-btn me-20 transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success"
                type="submit"
              >
                  Ajouter une filière par niveau
              </button>
              <router-link to="/liste-filiereNiveauMatieres" 
                  class=" btn btn-danger transition border-0 lh-1 fw-medium"><i class="flaticon-delete lh-1 me-1 position-relative top-2"></i>
                  <span class="position-relative"></span>Annuler</router-link>
            </div>
          </div>
        </div>
      </Form>
    </div>
  </div>
  </template>
  
  <script lang="ts">
  
  import { defineComponent, onMounted, ref} from 'vue';
  import { Form, Field, ErrorMessage } from 'vee-validate';
  import * as Yup from 'yup';
  import ApiService from '@/services/ApiService';
  
  import { error, success } from '@/utils/utils';
  import { useRouter } from 'vue-router';
  import Multiselect from '@vueform/multiselect/src/Multiselect';
  import { FiliereNiveauMatiere } from '@/models/FiliereNiveauMatiere';

  
  
  export default defineComponent({
      name: "AddFiliereNiveauMatiere",
      components: {
      Form,
      Field,
      ErrorMessage,
      Multiselect
    },
  
    setup: () => {
      const filiereNiveauMatiereSchema = Yup.object().shape({   
            coefficient: Yup.number().typeError("veuillez entrer des nombres").required("Le coefficient est obligatoire."),
            filiere: Yup.string().required("La filière est obligatoire."),
            matiere: Yup.string().required("La matière est obligatoire."),
            niveau: Yup.string().required("Le niveau est obligatoire."),
            
      });
  
      onMounted(() => {
        getAllFiliere()
        getAllMatiere()
        getAllNiveau()
      });
  
      const filiereNiveauMatiereForm =  ref(null);
      //const permissions = ref(null);
      const filiereOptions = ref([]);
      const matiereOptions = ref([]);
      const niveauOptions = ref([]);
      const router = useRouter();
      //const permissions= ref<Array<Permission>>([]);
    
    
    
      const addFiliereNiveauMatiere = async (values,{ resetForm }) => {
        values = values as FiliereNiveauMatiere;

        console.log(values, 'okokok')
        ApiService.post("/filiereNiveauMatieres",values)
        .then(({ data }) => {

          console.log (data, "ouiiiiiii")

          if(data.code == 201) { 
            success(data.message)
            resetForm();
            router.push({ name: "ListeFiliereNiveauMatierePage" });
          }
        }).catch(({ response }) => {
          error(response.message);
        });
      }
  
      const getAllFiliere = async () => {
        try{
        const response = await ApiService.get('/all/filieres');
        const filieresData = response.data.data.data;

        filiereOptions.value = filieresData.map((filiere) => ({
          value: filiere.id,
          label: filiere.libelle,
        }));
        }
        catch(error){
          //error(response.data.message)
        }
      } 


       const getAllNiveau = async () => {
        try{
        const response = await ApiService.get('/all/niveaux');
        const niveauxData = response.data.data.data;

        niveauOptions.value = niveauxData.map((niveau) => ({
          value: niveau.id,
          label: niveau.libelle,
        }));
        }
        catch(error){
          //error(response.data.message)
        }
      } 

      const getAllMatiere = async () => {
        try{
        const response = await ApiService.get('/all/matieres');
        const matieresData = response.data.data.data;

        matiereOptions.value = matieresData.map((matiere) => ({
          value: matiere.id,
          label: matiere.libelle,
        }));
        }
        catch(error){
          //error(response.data.message)
        }
      } 
  
      return { filiereNiveauMatiereSchema, addFiliereNiveauMatiere, filiereNiveauMatiereForm,filiereOptions,matiereOptions,niveauOptions};
    },
  });
  </script>